import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ChatBoxComponent } from './chat-box/chat-box.component';
import { MaterialModule } from 'src/app/material/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ChatLodgerComponent } from './chat-lodger/chat-lodger.component';
import { ChatOwnerComponent } from './chat-owner/chat-owner.component';
import { RouteLocataireGuard } from 'src/app/services/guards/routeLocataireGuard.guard';
import { RouteProprietaireGuard } from 'src/app/services/guards/routeProprietaireGuard.guard';


export const routes: Routes = [
  { path: '', redirectTo: 'locataire', pathMatch: 'full' },
  { path: 'locataire', canActivate: [RouteLocataireGuard],component: ChatLodgerComponent, data: { breadcrumb: 'Mes Messages' }},
  { path: 'proprietaire',canActivate: [RouteProprietaireGuard], component: ChatOwnerComponent, data: { breadcrumb: 'Mes Messages' }},
  { path: 'template', component: ChatBoxComponent},
];

@NgModule({
  declarations: [
    ChatBoxComponent,
    ChatLodgerComponent,
    ChatOwnerComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MaterialModule,
    ReactiveFormsModule
  ]
})
export class ChatModule { }
